const strings = {
  MANDATORY_FIELD: 'Fältet är oblikatoriskt',
  INFORMATION_UPDATED: 'Informationen har uppdaterats',
  INTERNAL_ERROR: 'Ett oväntat fel har uppstått, var god försök igen.',
  EDIT_INFORMATION: 'Ändra information',
  EDIT_INFORMATION_INFO: 'Fyll i fälten nedan för att ändra informationen.'
}

export default strings



// WEBPACK FOOTER //
// ./src/components/containers/EditInformationItemModal/strings.js